import { Typography } from 'common/typography'
import Link from 'next/link'
import styled from 'styled-components'
import useSession from 'querys/session'
import { SecondaryButton } from 'common/button'

const PortfolioCompletedStyled = styled.div`
  .portfolio-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font: var(--regularBold);
    span {
      color: var(--turquoise);
    }
  }
`

function PortfolioCompleted() {
  const { profile: { username } } = useSession()
  return (
    <PortfolioCompletedStyled className="progress-item">
      <div className="portfolio-title">
        <Typography font="regularBold">
          Portafolio
        </Typography>
        <span>100%</span>
      </div>
      <Typography font="p2Regular">
        ¡Felicitaciones!, tu portafolio es la prueba de tu experiencia a la hora de buscar un trabajo.
      </Typography>
      <Link href={`/estudiantes/${username}`} passHref>
        <SecondaryButton>
          Ver portafolio
        </SecondaryButton>
      </Link>
    </PortfolioCompletedStyled>
  )
}

export default PortfolioCompleted
